import React from 'react';
import MindTempWidget from '../components/MindTempWidget';
import icon from '../assets/icon_card_1.svg';
import '../styles/MindTempWidget.scss';

const ThermometerPage: React.FC = () => {
  return (
    <div className="thermometer-page-container">
      <div className="page-header">
        <img src={icon} alt="Mind Thermometer Icon" className="page-header__icon" />
        <h2 className="page-header__title">마음 온도계</h2>
        <p className="page-header__subtitle">오늘의 마음 온도를 기록하여 주세요.</p>
      </div>
      <MindTempWidget />
    </div>
  );
};

export default ThermometerPage;
